import { render, staticRenderFns } from "./Aquascapes.vue?vue&type=template&id=b2ff4662&lang=pug&"
import script from "./Aquascapes.vue?vue&type=script&lang=ts&"
export * from "./Aquascapes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports